<template>
  <div class="border-t border-t-grey-lighter">
    <div class="container">
      <ul class="flex gap-4">
        <li
          v-for="link in links"
          :key="link.id"
          :class="{
            'is-active': link.active,
            'is-enabled font-bold': link.enabled,
          }"
        >
          <a
            class="block py-4"
            :class="
              link.enabled
                ? 'text-grey-darker hover:text-black'
                : 'text-grey-light'
            "
            :href="link.url"
            :title="
              link.enabled
                ? 'Auf dieser Domain publiziert'
                : 'Auf dieser Domain nicht publiziert'
            "
            target="_blank"
            >{{ link.label }}</a
          >
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup lang="ts">
import { notNullish } from '@vueuse/core'

const route = useRoute()

const { data: domains } = await useAsyncGraphqlQuery('getDomains', null, {
  transform: function (data) {
    return (data.data.entityQuery.items || [])
      .map((v) => {
        if (v && 'enum' in v) {
          return v
        }

        return null
      })
      .filter(notNullish)
  },
})

// Same query and caching as the vuepal adapter, so the local tasks and the
// domain URLs share a single request.
const { data: domainUrls } = await useLazyAsyncData(
  () =>
    useGraphqlQuery(
      'adminPageContext',
      { path: route.path },
      {
        graphqlCaching: {
          client: true,
        },
      },
    ),
  {
    watch: [() => route.path],
    transform: function (data) {
      const drupalRoute = data.data.route
      if (!drupalRoute || !('entity' in drupalRoute) || !drupalRoute.entity) {
        return []
      }

      const entity = drupalRoute.entity
      if (!('domainUrls' in entity)) {
        return []
      }

      return entity.domainUrls
        .map((v) => {
          if (!v.urlPath) {
            return null
          }
          return {
            id: v.domainId,
            href: v.urlPath,
          }
        })
        .filter(notNullish)
    },
  },
)

const { activeDomain } = useSiteContext()

const links = computed(() => {
  return (domains.value || []).map((domain) => {
    const domainUrl = domainUrls.value?.find((v) => v.id === domain.enum)
    const fallback = `https://${domain.hostname}`

    return {
      id: domain.enum,
      label: domain.label || '',
      url: domainUrl?.href || fallback,
      active: domain.enum === activeDomain,
      enabled: !!domainUrl || domain.enum === activeDomain,
    }
  })
})
</script>
